/* eslint-disable @typescript-eslint/member-ordering */
import { Component, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BasicFormFields, CommonService, Destroy, FieldsService, FormBaseField, MODALCONFIG, PasswordFormFields, ToastService } from '@increff/commons';
import { PANELITEM } from '../../interfaces/panel-items.interface';
import { Rest, ConfigService } from '../../services';
import { AuthNGuardService } from '../../services/authn-guard.service';
import { UsersService } from '../../services/users/users.service';
import { CommonSidebarComponent } from '../inner-sidebar/common-sidebar.component';
import packageJson from 'package.json';

@Component({
    selector: 'com-navbar-routes',
    templateUrl: './navbar-routes.component.html',
    styleUrls: ['./navbar-routes.component.scss'],
    viewProviders: [Destroy]
})
export class NavbarRoutesComponent extends CommonSidebarComponent{

    public uiVersion = packageJson?.version;
    public navLinks;

    manageUserProfileModalConfig: MODALCONFIG;
    manageUserProfileFormFields: FormBaseField[] = [];
    manageUserProfileFormModel: {[key: string]: BasicFormFields };

    changeUserPasswordFormFields: FormBaseField[];
    changeUserPasswordFormModel: {[key: string]: PasswordFormFields };
    userRoutes: PANELITEM[] = [{
        name: 'Manage Profile',
        iconClass: 'account-edit',
        path: '/domain/profile',
    },
    ];
    private manageProfileBtnSpy: ElementRef<HTMLButtonElement>;
    constructor(
    public authService: AuthNGuardService,
    public rest: Rest,
    public configService: ConfigService,
    protected _router: Router,
    private commonService: CommonService,
    private fieldsService: FieldsService,
    private userService: UsersService,
    private toast: ToastService,
    private element: ElementRef,
    public activatedRoute: ActivatedRoute,
    protected readonly destroy$: Destroy
    ) {
        super(_router, configService, destroy$, authService);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.initTooltip();
            // this.userRoutes?.push(
            //     {
            //         name: 'Rule Engine',
            //         iconClass: 'file-cog',
            //         href: `${location.origin}${location.pathname?.split('ui')?.[0]?.replace(/\/+$/, '')}/rule-engine/#/`,
            //         showIf: this.authService?.currentUser?.roles?.includes('app.settings.admin')
            //     }
            // );
        }, 500);
    }

    initTooltip(): void {
        this.commonService.initTooltip('com-navbar-routes');
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    sendOutputEvent() {}

    toggleSideNav(sideNavSpy) {
        if (!sideNavSpy.classList.contains('show')) {
            sideNavSpy?.classList.add('show');
            sideNavSpy['dataShow'] = true;
            this.commonService.initTooltip('com-navbar');
            return;
        }
        sideNavSpy.classList.remove('show');
        sideNavSpy['dataShow'] = false;
        this.commonService.initTooltip('com-navbar');
    }

    toggleDropend({ target }) {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (!isMobile && !target.classList.contains('show'))
            if (target.getAttribute('data-bs-toggle') === 'dropdown') target.click();

    }

    clearLocalStorage() {
        localStorage.clear();
        localStorage.clear();
    }

    manageUsers() {
        window.open(this.rest.jumpUrl, '_blank');
    }

    logout() {
        this.clearLocalStorage();
        window.location.href = this.rest?.logoutUrl;
    }

}
